































































































import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Vue } from 'vue-property-decorator';

import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import WizardProgress from '@/modules/dap/components/wizard-progress/wizard-progress.vue';

import { CONFIG } from '@/config';
import { DAP_ROUTES } from '@/modules/dap/router';
import { IProject } from '@/modules/dap/interfaces';
import { dateService, httpService, stringService } from '@/services';

@Component({
  subscriptions () {
    return {
      searchValue$: this.$watchAsObservable('searchValue').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    PageLoader,
    WizardProgress
  }
})
export default class DapWizardNewPage extends Vue {
  public DAP_ROUTES = DAP_ROUTES;

  public currentPage: number = 1;
  public searchValue: string = '';
  public searchValue$: string;
  public parseDateToString = dateService.parseDateToString;
  private projects: Array<IProject> = [];

  public get projectsView () {
    const perPage = 15;
    const projects = _(this.projects)
      .filter(
        (p: IProject) =>
          _.size(this.searchValue$)
            ? stringService.normalize(p.name).includes(stringService.normalize(this.searchValue$))
            : true
      )
      .orderBy((p: IProject) => p.createdAt)
      .chunk(perPage)
      .value();

    const totalPages = projects.length;
    const page = this.currentPage > totalPages ? 1 : this.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      offset: (page - 1) * perPage,
      total: this.projects.length,
      totalPages,
      pages,
      data: projects[this.currentPage - 1] || []
    };
  }

  public goBack () {
    window.history.back();
  }

  public onSelect (id: number) {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_CONFIGURATION,
      params: {
        id: String(id)
      },
      query: {
        wizardStep: '1'
      }
    });
  }

  public created () {
    this.requestData();
  }

  private requestData () {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/dap/project`)
      .then((res: AxiosResponse) => {
        this.projects = res.data;
        console.log(this.projects);
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
